import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleSigninModule } from 'src/app/popupModel/google-signin-module';
import { LoginWithEmailModule } from '../login-with-email/login-with-email.module';
import { CountryPickerModule } from 'src/app/country-picker/country-picker.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    GoogleSigninModule,
    LoginWithEmailModule,
    CountryPickerModule
  ],
  exports: [LoginComponent]
})
export class LoginModule { }
